<template>
  <page-template type="rightpanel">
    <template v-slot:toolbar>
      <tool-bar type="back-arrow" :title="operation.title ? operation.title : 'Nouvelle Enquête'" linkback="/enquetes" class="px-8"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div>
          <enquetes-new :actions="items"></enquetes-new>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <guide-creation
        title="Aide a la création d’action"
        text="Le titre doit être court. Soyez précis sur le descriptif. Les photos ne doivent pas peser plus de 5 Mo."
      ></guide-creation>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import enquetesNew from '@/components/EnquetesNew.vue'
  import guideCreation from '@/components/GuideCreation.vue'
  export default {
    name: 'EnquetesNew',
    components: { pageTemplate, toolBar, enquetesNew, guideCreation },
    data: () => {
      return {
        items: [
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline' },
          { title: 'Déplacer vers le haut', icon: 'mdi-chevron-up' },
          { title: 'Déplacer vers le bas', icon: 'mdi-chevron-down' },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline' }
        ]
      }
    }
  }
</script>